import type {CSSProperties} from 'react';
import {wedgeExactRole as role} from './wedgeRoles.js';

export type WedgeDriveSettingsLook = 'drivesettings-goal' | 'drivesettings-goal-on' | 'drivesettings-rate' | 'drivesettings-rate-on' | 'drivesettings-preview' | 'drivesettings-preview-on';
const LOOKS: readonly string[] = ['drivesettings-goal', 'drivesettings-goal-on', 'drivesettings-rate', 'drivesettings-rate-on', 'drivesettings-preview', 'drivesettings-preview-on'];
export const isWedgeDriveSettingsLook = (look: string | undefined): look is WedgeDriveSettingsLook => look !== undefined && LOOKS.includes(look);

/* Drive Mode settings controls. Each keeps its released 44px box as the target, so none draws a transparent region. */
export function wedgeDriveSettingsStyle(look: WedgeDriveSettingsLook): CSSProperties {
  const on = look.endsWith('-on');
  const touch: CSSProperties = {touchAction: 'manipulation', WebkitTapHighlightColor: 'transparent'};
  if (look.startsWith('drivesettings-preview')) return {
    width: '100%', padding: 13, minHeight: 44, borderRadius: 12, border: 0, cursor: 'pointer',
    background: on ? role('bgElev') : role('accent'), color: on ? role('label') : 'white',
    fontFamily: role('font'), fontSize: 14, fontWeight: 700,
    display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 7, ...touch,
  };
  return {
    flex: look.startsWith('drivesettings-goal') ? '1 0 28%' : 1, padding: '11px 0', minHeight: 44, borderRadius: 11, cursor: 'pointer',
    background: on ? role('accentSoft') : role('bgElev'), color: on ? role('accent') : role('label'),
    border: `0.5px solid ${on ? role('accent') : role('separator')}`,
    fontFamily: role('font'), fontSize: 13.5, fontWeight: 700, ...touch,
  };
}
